module.exports = __webpack_public_path__ + "media/images/icons/flags/NZ-4a8657ee6af4048c07cd46e2e03ea34d.svg";